import { TaskEventDialog, useCreateScheduledTask } from '~/features/scheduled-tasks';
import { toast } from '~/hooks/use-toast';
import { useCommandBarStore } from '~/stores/command-bar.store';

/**
 * Mounts {@link TaskEventDialog} at the app root and toggles it via the
 * command-bar store. Lets any command bar action open the scheduled-task
 * creation flow without having to live near the calendar component.
 */
export function ScheduledTaskDialogHost() {
  const draft = useCommandBarStore((s) => s.scheduledTaskDraft);
  const closeDialog = useCommandBarStore((s) => s.closeScheduledTaskDialog);
  const createMutation = useCreateScheduledTask();

  const isOpen = draft !== null;

  const handleSubmit = async (body: Parameters<typeof createMutation.mutateAsync>[0]) => {
    try {
      await createMutation.mutateAsync(body);
      toast({ title: 'Task scheduled', variant: 'success' });
      closeDialog();
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Something went wrong';
      toast({ title: 'Failed to schedule task', description: message, variant: 'destructive' });
      throw err;
    }
  };

  return (
    <TaskEventDialog
      open={isOpen}
      onOpenChange={(next) => {
        if (!next) closeDialog();
      }}
      initialDraft={draft}
      onSubmit={handleSubmit}
      isSubmitting={createMutation.isPending}
    />
  );
}
